import * as React from 'react';

import {
	ApButtonOrange,
	ApButtonSecondary,
	ApButtonGroup,
} from '@alixpartners/ui-components';
import {
	Wrapper,
	ActionsWrapper,
	Title,
	Content,
	Header,
} from './PersonalizeOrder.styles';
import SortableList from './SortableList';
import { setLocalStorageItem, getLocalStorageItem } from 'utils/localStorage';

const LOCAL_STORAGE_KEY = 'PERSONALIZE-SPEND-CONFIG';

const DEFAULT_CONFIG_ITEMS = [
	{ id: 'RegionalSection', name: 'Regional Spend' },
	{ id: 'ShareOfTotalSpendSection', name: 'Vendor Fragmentation' },
	{ id: 'CommonVendors', name: 'Top 10 Vendors' },
	{ id: 'SpendOverTimeSection', name: 'Spend Over Time' },
	{
		id: 'CategorySpendTreeIndirect',
		name: 'Category Spend Tree (Indirect)',
	},
	{ id: 'CategorySpendTreeDirect', name: 'Category Spend Tree (Direct)' },
];

export class PersonalizeOrder extends React.Component {
	state = {
		isEdit: false,
		items: this.getInitialConfig(),
	};

	getInitialConfig() {
		const localStorageState = getLocalStorageItem(LOCAL_STORAGE_KEY);
		const { config } = this.props;

		return localStorageState || config || DEFAULT_CONFIG_ITEMS;
	}

	handleCancel = () => {
		this.setState({ isEdit: false, items: this.getInitialConfig() });
	};

	handlePersonalize = () => {
		this.setState({ isEdit: true });
	};

	handleHideClick = index => {
		const { items } = this.state;
		const newItems = [...items];
		const currentItem = { ...items[index] };

		if (!currentItem.hidden) {
			currentItem.hidden = true;

			newItems.splice(index, 1);
			newItems.push(currentItem);
		} else {
			const firstHiddenIndex = items.findIndex(item => item.hidden);
			currentItem.hidden = false;

			if (firstHiddenIndex !== index) {
				newItems.splice(index, 1);
				newItems.splice(firstHiddenIndex, 0, currentItem);
			} else {
				[newItems[index]] = [currentItem];
			}
		}

		this.setState({ items: newItems });
	};

	handleSortEnd = ({ oldIndex, newIndex }) => {
		const { items } = this.state;
		const firstHiddenIndex = items.findIndex(item => item.hidden);

		if (firstHiddenIndex !== -1 && newIndex >= firstHiddenIndex) {
			return;
		}

		const newItems = [...items];

		[newItems[oldIndex], newItems[newIndex]] = [
			newItems[newIndex],
			newItems[oldIndex],
		];

		this.setState({ items: newItems });
	};

	handleBackToDefault = () => {
		const { config } = this.props;

		this.setState({ items: config || DEFAULT_CONFIG_ITEMS });
	};

	saveToLocalStorage = () => {
		const { items } = this.state;

		setLocalStorageItem(LOCAL_STORAGE_KEY, items);
		this.setState({ isEdit: false });
	};

	render() {
		const { children } = this.props;
		const { isEdit, items } = this.state;

		return (
			<Wrapper>
				<Header>
					<Title>
						{isEdit ? (
							<React.Fragment>
								Setup your personal page order to see the most usefull
								information.
							</React.Fragment>
						) : (
							<React.Fragment>Detailed analysis</React.Fragment>
						)}
					</Title>
					<ActionsWrapper>
						{isEdit ? (
							<ApButtonGroup>
								<ApButtonSecondary
									onClick={this.handleBackToDefault}
									iconName="baseline_undo"
								>
									Back to default setup
								</ApButtonSecondary>
								<ApButtonSecondary
									onClick={this.handleCancel}
									iconName="baseline_close"
								>
									Cancel
								</ApButtonSecondary>
								<ApButtonOrange
									iconName="outline_done"
									onClick={this.saveToLocalStorage}
								>
									Save changes
								</ApButtonOrange>
							</ApButtonGroup>
						) : (
							<ApButtonSecondary
								onClick={this.handlePersonalize}
								iconName="baseline_tune"
							>
								Personalize page
							</ApButtonSecondary>
						)}
					</ActionsWrapper>
				</Header>
				<Content>
					{isEdit ? (
						<SortableList
							items={items}
							// Remove this prop to enable drag n drop on whole list item
							useDragHandle
							onHideClick={this.handleHideClick}
							onSortEnd={this.handleSortEnd}
						/>
					) : (
						children(items)
					)}
				</Content>
			</Wrapper>
		);
	}
}
